// RayAid theme — small interactions

(function() {
  // Sticky header background swap
  const header = document.querySelector('.ra-header');
  if (header) {
    const onScroll = () => {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Reviews carousel — click dot to switch + auto-rotate
  document.querySelectorAll('[data-reviews]').forEach(root => {
    const slides = root.querySelectorAll('[data-review-slide]');
    const dots = root.querySelectorAll('[data-review-dot]');
    if (slides.length < 2) return;
    let i = 0;
    const show = (n) => {
      slides.forEach((s, idx) => {
        s.style.display = idx === n ? 'block' : 'none';
        if (idx === n) s.style.animation = 'fadeIn .5s ease';
      });
      dots.forEach((d, idx) => d.setAttribute('aria-current', idx === n ? 'true' : 'false'));
      i = n;
    };
    dots.forEach((d, idx) => d.addEventListener('click', () => show(idx)));
    show(0);
    setInterval(() => show((i + 1) % slides.length), 7000);
  });

  // Product filters (client-side toggle on data-tag attr)
  document.querySelectorAll('[data-shop-filters]').forEach(root => {
    const buttons = root.querySelectorAll('[data-filter]');
    const cards = root.querySelectorAll('[data-product-tag]');
    buttons.forEach(b => b.addEventListener('click', () => {
      const f = b.getAttribute('data-filter');
      buttons.forEach(x => x.setAttribute('aria-pressed', x === b ? 'true' : 'false'));
      cards.forEach(c => {
        const tags = (c.getAttribute('data-product-tag') || '').toLowerCase();
        c.style.display = (f === 'all' || tags.includes(f.toLowerCase())) ? '' : 'none';
      });
    }));
  });
})();
